import {
  type AdvancePaymentInvoiceDetails,
  type ChargeInvoiceDetails,
  type InvoiceDomainSelectModel,
  InvoiceId,
  type InvoiceType,
  InvoiceTypes,
  type PaymentInvoiceDetails,
  ProjectId,
} from '@mntn-dev/domain-types'
import { getRandomItem, UnhandledUnionError } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockInvoiceDetails = (
  invoiceType: InvoiceType
): InvoiceDomainSelectModel['details'] => {
  switch (invoiceType) {
    case 'charge': {
      return {
        invoiceType,
        metadata: {},
      } satisfies ChargeInvoiceDetails
    }

    case 'payment': {
      return {
        invoiceType,
        metadata: {},
      } satisfies PaymentInvoiceDetails
    }

    case 'advance-payment': {
      return {
        invoiceType,
        metadata: {
          needed_by_date: new Date().toISOString(),
          reason: 'Show me the money!',
          fee_exemption: false,
          over_limit_exception: false,
          multiple_advances_exception: false,
          advance_percent: 10,
          maker_payout_total: 10000,
        },
      } satisfies AdvancePaymentInvoiceDetails
    }

    default:
      throw new UnhandledUnionError(invoiceType)
  }
}

export const MockInvoice = MockModel<InvoiceDomainSelectModel>(
  ({
    invoiceId = InvoiceId(),
    projectId = ProjectId(),
    amount = 10000 * 10,
    description = `Invoice ${invoiceId}`,
    status = 'pending',
    details = MockInvoiceDetails(getRandomItem(InvoiceTypes)),
  }) => {
    return {
      invoiceId,
      projectId,
      amount,
      description,
      status,
      details,
    } satisfies InvoiceDomainSelectModel
  }
)
